import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

function ImageSliders(props) {
  const images = props.images || [];
  return (
    <>
      <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
        {images.map((imgs, index) => (
          <SwiperSlide key={index}>
            <img src={imgs} alt={index} />
          </SwiperSlide>
        ))}
        x
      </Swiper>
    </>
  );
}
export default React.memo(ImageSliders);
